export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function log(...val) {
  if (window.dev) {
    console.log("log:", ...val)
  }
}

export function getPerc(nom, denom) {
  let decimal = (nom / denom)
  let decTwoPrecision = decimal.toFixed(2)
  let r = Number(decTwoPrecision)
  return r
}

export const UNKNOWN = 0
export const TIGHT = 100
export const LOOSE = 400
export const NOT_SERIOUS = 500
export const humanCategoryObj = {
  0: 'unknown',
  100: 'tight',
  400: 'loose',
  500: 'notserious'
}

let arr = []
export function pushArr(obj) {
  obj.ut = Date.now();
  arr.push(obj)
  console.log("arr", arr)
  arr.sort((a, b) => {
    if (a.ut !== b.ut) return a.ut - b.ut;
    if (a.action === 'call' || a.action === 'smallBlindCall') return -1;
    return 1;
  });
  console.log("arr sorted", arr)
}

export function getHumanCategory(gameObj) {
  let index = getHumanCategoryIndex(gameObj)
  let cat = humanCategoryObj[index]
  return cat
}

export function getHumanCategoryIndex(gameObj) {
//return NOT_SERIOUS
  // https://www.smartpokerstudy.com/4-common-poker-player-types/
  // A tight player plays few hands (VPIP < 20%), and a loose player plays a lot of hands (VPIP > 20%).
  // A passive player doesn’t raise preflop that often (PFR < 15%) and an aggressive player raises a lot (PFR > 15%) mega-aggressive player at 45%
  // LOOSE = Plays lots of hands; PASSIVE = prefer making checks and call; they love to see flops; they stay in way too long with weak hands and draws; #1 targets at the table; if they raise post-flop, WATCH OUT!
  // TIGHT = Plays mostly strong hands, PASSIVE = prefer checks and calls (but sometimes they’re aggressive with few calling hands); quick to fold post-flop; beware their bets and raises.
  // TIGHT = Plays mostly strong hands, AGGRESSIVE = prefers bets and raises;

  if (typeof gameObj === 'undefined' || typeof gameObj.numHands === 'undefined') {
    //let tmp = 1
    return UNKNOWN
  }
  // Loose-Passive - sees 30% to 100% of flops. Plays K3 suited
  // Loose-Aggressive - any two cards at any time
  // Tight-Passive -  rarely bet. They are happy to call and fold, but they are not often seen making raises
  // Tight-Aggressive - raise and reraise significantly more than the average. Reraise you whilst on a flush draw, or whilst holding second pair.

  // START handle players that just click allIn or 'pot' immediately
  //
  if (gameObj.humanHistoryObj['perc_allIn'] >= 100 && gameObj.numHands >= 2) {
    return NOT_SERIOUS
  }
  if (gameObj.humanHistoryObj['perc_raise'] >= 100 && gameObj.numHands >= 2) {
    return NOT_SERIOUS
  }
  //
  // END handle players that just click allIn or 'pot' immediately

  if (gameObj.numHands < 4) {
    //console.log("human is unknown")
    return UNKNOWN
  }
  if (gameObj.humanHistoryObj['perc_allIn'] >= 50 || gameObj.humanHistoryObj['perc_raise'] >= 50) {
    //console.log("0 human is not serious")
    return NOT_SERIOUS
  }
  if (gameObj.humanHistoryObj['perc_allIn'] >= 30) {
    //console.log("A human is loose")
    return LOOSE
  }
  if (gameObj.humanHistoryObj['perc_raise'] >= 40) {
    //console.log("B human is loose")
    return LOOSE
  }
  if (gameObj.humanHistoryObj['perc_call'] >= 50 || gameObj.humanHistoryObj['perc_check'] >= 50
    || gameObj.humanHistoryObj['perc_fold'] >= 50) {
    //console.log("C human is tight")
    return TIGHT
  }
  if (gameObj.humanHistoryObj['perc_raise'] < 40 || gameObj.humanHistoryObj['perc_check'] < 40) {
  //   //console.log("D human is tight")
     return TIGHT
  }
  if (gameObj.humanHistoryObj['perc_fold_preflop'] > 30) {
    //console.log("E human is tight")
    return TIGHT
  }

  //console.log("E human is unknown")
  return UNKNOWN

}

export function addToCardArr(arr,addCard) {
  arr.push(addCard)
  // sort desc
  arr.sort((firstItem, secondItem) => secondItem - firstItem);
  return arr
}

export function getCardPositionAgainstBoard(cardRank, analysisObj) {
  let position = 1 //best
  for (let i in analysisObj.boardObj.bestcardsArr) {
    if (typeof analysisObj.boardObj.bestcardsArr[i] === 'undefined') {
      continue
    }
    let boardCardRank = analysisObj.boardObj.bestcardsArr[i].rank
    if (boardCardRank > cardRank) {
      position++
    }
  }
  return position
}

export function getCardPositionAgainstCardRankArr(cardRank, cardRankArr) {
  let position = 1; //best
  for (const testCardRank of cardRankArr) {
    if (cardRank < testCardRank) {
      position++;
    }
  }
  return position;
}

export function hasStreetHistory(gameObj) {
  return !!(gameObj.streetHistoryArr && gameObj.streetHistoryArr.length);
}

export function getLastRowForStreet(gameObj) {
  if (hasStreetHistory(gameObj)) {
    const lastRow = gameObj.streetHistoryArr[gameObj.streetHistoryArr.length - 1];
    return lastRow.street === gameObj.street ? lastRow : false;
  }
  return false;
}

export function getLastRow(gameObj) {
  if (hasStreetHistory(gameObj)) {
    return gameObj.streetHistoryArr[gameObj.streetHistoryArr.length - 1]
  }
  return false
}

export function getSecondToLastRow(gameObj) {
  if (hasStreetHistory(gameObj)) {
    return gameObj.streetHistoryArr[gameObj.streetHistoryArr.length - 2]
  }
  return false
}

export function getThirdToLastRow(gameObj) {
  if (hasStreetHistory(gameObj) && typeof gameObj.streetHistoryArr[gameObj.streetHistoryArr.length - 3] !== 'undefined') {
    return gameObj.streetHistoryArr[gameObj.streetHistoryArr.length - 3]
  }
  return false
}

export function getPreviousActionOnStreet(gameObj) {
  if (hasStreetHistory(gameObj)) {
    let lastRow = getLastRow(gameObj)
    let secondToLastRow = getSecondToLastRow(gameObj)
    if (lastRow && secondToLastRow && lastRow.street === secondToLastRow.street && lastRow.street === gameObj.street) {
      return secondToLastRow.action + " " + lastRow.action
    } else if (lastRow && lastRow.street === gameObj.street) {
      return lastRow.action
    }
  }
  return false
}

export function getLastRowByActor(gameObj, actor) {
  let lastRow = false
  if (hasStreetHistory(gameObj)) {
    let l = gameObj.streetHistoryArr.length - 1
    for (let i = l; i >=0; i--) {
      let row = gameObj.streetHistoryArr[i]
      if (row.actor !== actor) {
        continue
      }
      lastRow = {...row}
      break
    }
  }
  return lastRow
}

export function getSecondToLastRowByActor(gameObj, actor) {
  let secondToLastRow = false
  let num = 0
  if (hasStreetHistory(gameObj)) {
    let l = gameObj.streetHistoryArr.length - 1
    for (let i = l; i >=0; i--) {
      let row = gameObj.streetHistoryArr[i]
      if (row.actor !== actor) {
        continue
      }
      num++
      if (num < 2) {
        continue;
      }
      secondToLastRow = {...row}
      break
    }
  }
  return secondToLastRow
}

export function getAllPreviousActionOnStreet(gameObj) {
  if (hasStreetHistory(gameObj)) {
    return gameObj.streetHistoryArr
      .filter(row => row.street === gameObj.street)
      .map(row => ({...row}));
  }
  return [];
}

export function getEquityCallAmount(gameObj) {
  // Required equity = price of calling / (pot size + price of calling)
  let pot = gameObj.pot
  let bet = gameObj.betObj.minCallAmount
  let denom = pot + bet
  let size = parseInt((bet / denom) * 100)
  size = roundToNearestBB(size, gameObj)
  return size
}

export function getEquityDrawAmount(analysisObj, gameObj, infoObj) {

  let betEquityObj = infoObj.betEquityObj

  let drawProbabilityPerc = analysisObj.drawObj.drawProbability

  let bestEquityPercDiff = 100
  let bestBetType = ''
  //let betEquityWinPerc = 0
  for(let betType in betEquityObj) {
    let tmpEquityWinPerc = betEquityObj[betType] // 50
    let drawProbabilityLessEquityWinPerc = drawProbabilityPerc - tmpEquityWinPerc // 52 - 50 = 2
    if (tmpEquityWinPerc <= drawProbabilityPerc && drawProbabilityLessEquityWinPerc < bestEquityPercDiff) {
      // 50 < 52 && 2 < 100 so new bestEquityDiff is 2,
      // bestBet is whatever calcBetEquity() set for betType (eg. betPot, betOneBB, etc)
      bestEquityPercDiff = drawProbabilityPerc - tmpEquityWinPerc
      bestBetType = betType
    }
  }

  if (bestBetType) {
    if (bestBetType === 'betPot') {
      return gameObj.pot
    } else if (bestBetType === "betHalfPot") {
      let bet = gameObj.pot / 2
      if (bet % gameObj.bigBlind !== 0) {
        // make sure bet is in big blind increments
        // bet of 30 mod big blind of 20 = 10
        // 30 - 10 + 20 = 40
        bet = bet - (bet % gameObj.bigBlind) + gameObj.bigBlind
      }
      return bet
    } else if (bestBetType === "betOneBB") {
      return gameObj.bigBlind
    } else if (bestBetType === "betTwoBB") {
      return gameObj.bigBlind * 2
    } else if (bestBetType === "betThreeBB") {
      return gameObj.bigBlind * 3
    } else if (bestBetType === "betFourBB") {
      return gameObj.bigBlind * 4
    } else if (bestBetType === "betFiveBB") {
      return gameObj.bigBlind * 5
    } else if (bestBetType === "betAllIn") {
      return gameObj.computerChips
    }
  } else {
    return false
  }
}

// Break down bet size by big blind size
export function getBetEquityObj(gameObj, roundingDirection) {
  // Required equity = bet / (pot size + bet)
  let obj = {}
  obj.betOneBB = gameObj.bigBlind
  obj.betTwoBB = gameObj.bigBlind * 2
  obj.betThreeBB = gameObj.bigBlind * 3
  obj.betFourBB = gameObj.bigBlind * 4
  obj.betFiveBB = gameObj.bigBlind * 5
  obj.betPot = gameObj.pot
  obj.betHalfPot = Math.ceil(gameObj.pot / 2)
  obj.betAllIn = gameObj.computerChips
  for(let i in obj) {
    let bet = obj[i]
    let pot = gameObj.pot
    let denom = pot + bet
    obj[i] = parseInt((bet / denom) * 100)
    if (roundingDirection === 'to nearest') {
      obj[i] = roundToNearestBB(obj[i], gameObj)
    } else if (roundingDirection === 'down') {
      obj[i] = roundDownToNearestBB(obj[i], gameObj)
    } else {
      obj[i] = roundUpToNearestBB(obj[i], gameObj)
    }
  }
  return obj
}

export function getPreviousStreetBet(gameObj) {
  let betObj = {}
  betObj.computer = {action:"", betAmount:0,betNumBB:0}
  betObj.human = {action:"", betAmount:0,betNumBB:0}
  if (hasStreetHistory(gameObj)) {
    for (let i in gameObj.streetHistoryArr) {
      let row = {...gameObj.streetHistoryArr[i]}
      if (row.street === gameObj.street) {
        break
      }
      if (row.actor === 'computer') {
        betObj.computer.action = row.action
        betObj.computer.street = row.street
        betObj.computer.betAmount = row.betAmount
        betObj.computer.betNumBB = parseInt(row.betAmount / gameObj.bigBlind)
      } else if (row.actor === 'human') {
        betObj.human.action = row.action
        betObj.human.street = row.street
        betObj.human.betAmount = row.betAmount
        betObj.human.betNumBB = parseInt(row.betAmount / gameObj.bigBlind)
      }
    }
  }
  return betObj
}

export function getActionForHand(gameObj) {

  let compressedStreetHistoryArr = getCompressedStreetHistoryArr(gameObj)
  let obj = {}
  obj.limpedIn = true
  obj.streetNum = 1
  obj.totalChipsBet = 0
  obj.totalCalls = 0
  obj.totalRaises = 0
  obj.totalReraises = 0
  obj.totalCheckCalls = 0
  //obj.totalRaisesAndReraises = 0
  obj.totalChecks = 0
  obj.byStreetObj = {}
  obj.byStreetObj.preflop = {}
  obj.byStreetObj.preflop.numCalls = 0
  obj.byStreetObj.preflop.numRaises = 0
  obj.byStreetObj.preflop.numReraises = 0
  obj.byStreetObj.preflop.numChecks = 0
  obj.byStreetObj.preflop.numCheckCalls = 0
  obj.byStreetObj.preflop.chipsBet = 0
  obj.byStreetObj.flop = {}
  obj.byStreetObj.flop.numCalls = 0
  obj.byStreetObj.flop.numRaises = 0
  obj.byStreetObj.flop.numReraises = 0
  obj.byStreetObj.flop.numChecks = 0
  obj.byStreetObj.flop.numCheckCalls = 0
  obj.byStreetObj.flop.chipsBet = 0
  obj.byStreetObj.turn = {}
  obj.byStreetObj.turn.numCalls = 0
  obj.byStreetObj.turn.numRaises = 0
  obj.byStreetObj.turn.numReraises = 0
  obj.byStreetObj.turn.numChecks = 0
  obj.byStreetObj.turn.numCheckCalls = 0
  obj.byStreetObj.turn.chipsBet = 0
  obj.byStreetObj.river = {}
  obj.byStreetObj.river.numCalls = 0
  obj.byStreetObj.river.numRaises = 0
  obj.byStreetObj.river.numReraises = 0
  obj.byStreetObj.river.numChecks = 0
  obj.byStreetObj.river.numCheckCalls = 0
  obj.byStreetObj.river.chipsBet = 0
  let arr = []
  arr['human'] = {...obj}
  arr['computer'] = {...obj}
  if (gameObj.street ==='river') {
    //let tmp = 1
  }
  for(let i in compressedStreetHistoryArr) {
    let streetObj = compressedStreetHistoryArr[i]
    if (streetObj.street === 'preflop' && streetObj.actor === 'human') {
      //let tmp = 1
    }
    if ((streetObj.street === 'preflop' && streetObj.action === 'raise')
      || (streetObj.street === 'preflop' && streetObj.action === 'call')
    ) {
      arr[streetObj.actor].limpedIn = false
    }
    if (streetObj.action === 'smallBlindCall' || streetObj.action === 'bigBlind' || streetObj.action === 'smallBlind') {
      continue
    }

    let action = streetObj.action
    // see if the raise is a re-raise
    if (action === 'raise' && i > 0) {
      let prevActionObj = compressedStreetHistoryArr[i - 1]
      if (prevActionObj.street === streetObj.street && prevActionObj.actor !== streetObj.actor && prevActionObj.action === 'raise') {
        action = 'reraise'
        break
      }
    } else if (action === 'call' && i > 1) {
      let prevActionObj = compressedStreetHistoryArr[i - 2]
      if (prevActionObj.street === streetObj.street && prevActionObj.actor !== streetObj.actor && prevActionObj.action === 'check') {
        action = 'checkcall'
        break
      }
    }
    if (streetObj.street === 'preflop') {
      arr[streetObj.actor].streetNum = 1
    } else if (streetObj.street === 'flop') {
      arr[streetObj.actor].streetNum = 2
    } else if (streetObj.street === 'turn') {
      arr[streetObj.actor].streetNum = 3
    } else if (streetObj.street === 'river') {
      arr[streetObj.actor].streetNum = 4
    }

    if (action === 'reraise') {
      // TODO increment 'raise' along with 'reraise' here?
      arr[streetObj.actor].totalReraises++
      arr[streetObj.actor].totalChipsBet += streetObj.betAmount
      arr[streetObj.actor].byStreetObj[streetObj.street].numReraises++
    } else if (action === 'raise') {
      arr[streetObj.actor].totalRaises++
      arr[streetObj.actor].totalChipsBet+= streetObj.betAmount
      arr[streetObj.actor].byStreetObj[streetObj.street].numRaises++
    } else if (action === 'call') {
      arr[streetObj.actor].totalCalls++
      arr[streetObj.actor].totalChipsBet+= streetObj.betAmount
      arr[streetObj.actor].byStreetObj[streetObj.street].numCalls++
    } else if (action === 'check') {
      arr[streetObj.actor].totalChecks++
      arr[streetObj.actor].byStreetObj[streetObj.street].numChecks++
    } else if (action === 'checkcall') {
      arr[streetObj.actor].totalCheckCalls++
      arr[streetObj.actor].byStreetObj[streetObj.street].numCheckCalls++
    }
    arr[streetObj.actor].totalChipsBet+= streetObj.betAmount
    arr[streetObj.actor].byStreetObj[streetObj.street].chipsBet+= streetObj.betAmount
    //arr[streetObj.actor].totalBothRaisesAndReraises = arr[streetObj.actor].totalReraises + arr[streetObj.actor].totalRaises
  }

  return arr
}

// score - a raise or reraise on every street is 1000
// 400 or below is likely a draw
/*
export function getHumanHandAggressionScore(gameObj) {

  if (typeof gameObj.actionForHandArr === 'undefined') {
    return 0
  }
  let humanBetObj = gameObj.actionForHandArr['human']

  if (gameObj.street === 'flop') {
   // let tmp = 1
  }

  let streetNum = humanBetObj.streetNum
  let score = 0
  if (humanBetObj.totalReraises >= streetNum) {
    score = 1000
  } else if (humanBetObj.totalRaises >= streetNum) {
    score = 700
  } else if (humanBetObj.totalReraises > 0 || humanBetObj.totalRaises > 0) {
    score = 500
  } else if (humanBetObj.totalCalls === streetNum) {
    score = 400
  } else if (humanBetObj.totalChecks === streetNum && humanBetObj.limpedIn) {
    score = 300
  } else if (humanBetObj.totalReraises === 0 && humanBetObj.totalRaises === 0 && humanBetObj.limpedIn) {
    score = 300
  }
  return score
}
*/
export function getHandWonAmount(actor, gameObj) {

  let amount = 0
  for(let i in gameObj.streetHistoryArr) {
    let obj = gameObj.streetHistoryArr[i]
    if (obj.actor !== actor) {
      amount+=obj.betAmount
    }
  }
  return amount
}

export function getTotalAmountBetForHandByActor(actor, gameObj) {

  let amount = 0
  for(let i in gameObj.streetHistoryArr) {
    let obj = gameObj.streetHistoryArr[i]
    if (obj.actor === actor) {
      amount+=obj.betAmount
    }
  }
  return amount
}

export function getCompressedStreetHistoryArr(gameObj) {
  const compressedStreetHistoryArr = [];
  for (let i = 0; i < gameObj.streetHistoryArr.length; i++) {
    const obj = { ...gameObj.streetHistoryArr[i] };
    if (obj.action === 'call') {
      const nextObj = gameObj.streetHistoryArr[i + 1];
      if (nextObj && nextObj.action === 'raise') {
        obj.action = 'raise';
        obj.betAmount += nextObj.betAmount;
        i++; // Skip nextObj
      }
    }
    compressedStreetHistoryArr.push(obj);
  }
  return compressedStreetHistoryArr;
}

export function getMaxBetPrev(gameObj) {
  let arr = getCompressedStreetHistoryArr(gameObj)
  let maxBet = 0
  for(let obj of arr) {
    if (obj.betAmount > maxBet) {
      maxBet = obj.betAmount
    }
  }
  return maxBet
}

// This gets called after a method is complete and returns the next player to forward the action to
export function getPlayerBetTurn(value, useWait, useComputerWait) {
  let playerTurn
  if ((useComputerWait || useWait) && value === 'human') {
    playerTurn = 'waitcomputer'
  } else if (useWait && value === 'computer') {
    playerTurn = 'waithuman'
  } else if (value === 'human') {
    playerTurn = 'computer'
  } else {
    playerTurn = 'human'
  }
  return playerTurn
}

// Evaluate actions based on the number of hands, streets and actions
// there can be multiple actions on a street: check, then re-raising a raise, and then folding and so on
export function sumActionHistory(gameObj) {

  let compressedStreetHistoryArr = getCompressedStreetHistoryArr(gameObj)
  let numHands = gameObj.numHands - 1
  let humanHistoryObj = {...gameObj.humanHistoryObj}
  let computerHistoryObj = {...gameObj.computerHistoryObj}
  if (gameObj.street === 'done' && gameObj.previousBetType !== 'folded') {
    humanHistoryObj['showdown'] = ++humanHistoryObj['showdown']
    computerHistoryObj['showdown'] = ++computerHistoryObj['showdown']
    if (gameObj.handWinner === "Computer") {
      computerHistoryObj['showdown_won'] = ++computerHistoryObj['showdown_won']
    } else {
      humanHistoryObj['showdown_won'] = ++humanHistoryObj['showdown_won']
    }
    humanHistoryObj['perc_showdown'] = Math.ceil(humanHistoryObj['showdown']/numHands)
    computerHistoryObj['perc_showdown'] = Math.ceil(computerHistoryObj['showdown']/numHands)
  }
  let numStreetsForHand = 1
  let prevStreet = 'preflop'
  let isSetHumanSawFlopAsBigBlind = false
  let isSetComputerSawFlopAsBigBlind = false
  let isSetHumanSawFlopAsSmallBlind = false
  let isSetComputerSawFlopAsSmallBlind = false
  let skipPropArr = ['num_actions', 'num_streets', 'num_hands']
  let useNumActionsAsDenomArr = ['check','call','raise']
  let useNumHandsAsDenomArr = ['allIn', 'fold', 'fold_preflop', 'saw_flop_as_small_blind','saw_flop_as_big_blind', 'showdown', 'showdown_won']
  for(let i in compressedStreetHistoryArr) {
    let row = compressedStreetHistoryArr[i]
    if (row.action === 'bigBlind' || row.action === 'smallBlind' || row.action === 'smallBlindCall') {
      continue
    }
    let currentStreet = row.street
    if (currentStreet !== prevStreet) {
      numStreetsForHand++
    }
    if (row.actor === 'human') {
      humanHistoryObj['num_actions'] = ++humanHistoryObj['num_actions']
      if (row.street === 'preflop' && row.action === 'fold') {
        humanHistoryObj['fold_preflop'] = ++humanHistoryObj['fold_preflop']
      }
      if (row.street === 'flop' && gameObj.bigBlindPlayer === 'human' && !isSetHumanSawFlopAsBigBlind) {
        humanHistoryObj['saw_flop_as_big_blind'] = ++humanHistoryObj['saw_flop_as_big_blind']
        isSetHumanSawFlopAsBigBlind = true
      } else if (row.street === 'flop' && gameObj.smallBlindPlayer === 'human' && !isSetHumanSawFlopAsSmallBlind) {
        humanHistoryObj['saw_flop_as_small_blind'] = ++humanHistoryObj['saw_flop_as_small_blind']
        isSetHumanSawFlopAsSmallBlind = true
      }
      let num = humanHistoryObj[row.action]
      num++
      humanHistoryObj[row.action] = num
    } else {
      computerHistoryObj['num_actions'] = ++computerHistoryObj['num_actions']
      if (row.street === 'preflop' && row.action === 'fold') {
        computerHistoryObj['fold_preflop'] = ++computerHistoryObj['fold_preflop']
      }
      if (row.street === 'flop' && gameObj.bigBlindPlayer === 'computer' && !isSetComputerSawFlopAsBigBlind) {
        computerHistoryObj['saw_flop_as_big_blind'] = ++computerHistoryObj['saw_flop_as_big_blind']
        isSetComputerSawFlopAsBigBlind = true
      } else if (row.street === 'flop' && gameObj.smallBlindPlayer === 'computer' && !isSetComputerSawFlopAsSmallBlind) {
        computerHistoryObj['saw_flop_as_small_blind'] = ++computerHistoryObj['saw_flop_as_small_blind']
        isSetComputerSawFlopAsSmallBlind = true
      }
      let num = computerHistoryObj[row.action]
      num++
      computerHistoryObj[row.action] = num
    }
    prevStreet = row.street
  }
  let numStreets = gameObj.numStreets + numStreetsForHand;
  for(let prop in humanHistoryObj) {
    if (prop.includes("perc_") || skipPropArr.includes(prop)) {
      continue
    }
    let percProp = 'perc_' + prop
    let denom
    if (useNumHandsAsDenomArr.includes(prop)) {
      denom = numHands
    } else if (useNumActionsAsDenomArr.includes(prop)) {
      denom = humanHistoryObj['num_actions']
    } else {
      console.log("prop " + prop + " is using numStreets as denom")
      denom = numStreets
    }
    humanHistoryObj[percProp] = parseInt(Number(((humanHistoryObj[prop] / denom) * 100)))
  }
  for(let prop in computerHistoryObj) {
    if (prop.includes("perc_") || skipPropArr.includes(prop)) {
      continue
    }
    let percProp = 'perc_' + prop
    let denom
    if (useNumHandsAsDenomArr.includes(prop)) {
      denom = numHands
    } else if (useNumActionsAsDenomArr.includes(prop)) {
      denom = computerHistoryObj['num_actions']
    } else {
      console.log("prop " + prop + " is using numStreets as denom")
      denom = numStreets
    }
    computerHistoryObj[percProp] = parseInt(Number(((computerHistoryObj[prop] / denom) * 100)))
  }

  humanHistoryObj['num_streets'] = numStreets
  computerHistoryObj['num_streets'] = numStreets
  humanHistoryObj['num_hands'] = numHands
  computerHistoryObj['num_hands'] = numHands

  gameObj.humanHistoryObj = {...humanHistoryObj}
  gameObj.computerHistoryObj = {...computerHistoryObj}

  return gameObj

}

export function roundTo10(analysisObj, direction) {
  let drawProb = analysisObj.drawObj.drawProbability
  if (direction === 'up') {
    let remainder = drawProb % 10
    if (remainder >= 5) {
      drawProb = drawProb - remainder + 10
    }
  } else if (direction === 'down') {
    let remainder = drawProb % 10
    drawProb = drawProb - remainder
  }
  return drawProb
}

export function roundToNearestBB(bet, gameObj) {

  let bigBlind = gameObj.bigBlind
  let numBigBlinds = parseInt(bet / bigBlind)
  let remainder = bet % bigBlind
  if (remainder > bigBlind / 2) {
    bet = numBigBlinds * bigBlind + bigBlind
  } else {
    bet = numBigBlinds * bigBlind
  }
  if (bet === 0) {
    bet = bigBlind
  }
  return bet

}

export function roundUpToNearestBB(bet, gameObj) {

  let bigBlind = gameObj.bigBlind
  let numBigBlinds = parseInt(bet / bigBlind)
  let remainder = bet % bigBlind
  if (remainder > 0) {
    bet = numBigBlinds * bigBlind + bigBlind
  } else {
    bet = numBigBlinds * bigBlind
  }

  return bet

}

export function roundDownToNearestBB(bet, gameObj) {

  let bigBlind = gameObj.bigBlind
  let numBigBlinds = parseInt(bet / bigBlind)
  bet = numBigBlinds * bigBlind
  if (bet === 0) {
    bet = bigBlind
  }
  return bet

}

export function calcBigBlinds(gameObj) {
  let lastRow = getLastRow(gameObj)
  let bbObj = {}
  bbObj.numBBRemaining = parseInt(gameObj.computerChips / gameObj.bigBlind)
  bbObj.numBBInPot = parseInt(gameObj.pot / gameObj.bigBlind)
  bbObj.numBBInPreviousRaise = parseInt(lastRow.betAmount / gameObj.bigBlind)
  bbObj.numBBRemainingPostCall = parseInt((gameObj.computerChips - lastRow.betAmount) / gameObj.bigBlind)
  bbObj.numBBStarting = parseInt(gameObj.startingChips / gameObj.bigBlind)
  return bbObj
}

function getDisplayAction(action) {
  let display = ''
  if (action === 'smallBlindCall') {
    display = 'small blind calls'
  } else if (action === 'allIn') {
    display = 'all in'
  } else {
    display = action + 's'
  }

  return display
}

export function getActionMsg(gameObj){

  // This method gets called after action is complete and the next playerBetTurn is set in gameObj. So use
  // getLastRow() methods for history, not gameObj.playerBetTurn, gameObj.previousBetType etc values
  let msg = ''
  if (gameObj.gameOver) {
    msg = gameObj.handWinner + " won. Match has ended. "
  } else {
    if (gameObj.handWinner === 'Tie') {
      msg = 'Tie. '
    }
    if (gameObj.handWonAmount > 0) {
      let handWonAmount = getHandWonAmount(gameObj.handWinner, gameObj)
      msg+= gameObj.handWinner + ' wins ' + handWonAmount + " pot. &nbsp; "
    } else if (gameObj.readyForNextHand) {
      msg+= "Hand complete. "
    } else {

      if (gameObj.playerBetTurn !== 'waithuman' && gameObj.playerBetTurn !== 'waitcomputer') {
        if (gameObj.playerBetTurn === 'human') {
          msg = "Action to Human"
        } else {
          msg = "Action to Computer"
        }
      }
    }

  }
  return msg
}

// function getRowNumForActionOnStreet(gameObj, actor, street, action, betAmount) {
//   let num = 0
//   let finalNum = 0
//   if (hasStreetHistory(gameObj)) {
//     let l = gameObj.streetHistoryArr.length
//     for (let i = 0; i < l; i++) {
//       let row = gameObj.streetHistoryArr[i]
//       if (row.action === 'bigBlind' || row.action === 'smallBlind') {
//         continue;
//       }
//       if (row.street === street) {
//         num++
//         if (actor === row.actor && action === row.action && betAmount === row.betAmount) {
//           finalNum = num
//         }
//       }
//     }
//   }
//   return finalNum
// }

// function getSeqNum(gameObj, street, lastRow) {
//   let humanNum = getRowNumForActionOnStreet(gameObj, "human", street, lastRow.action, lastRow.betAmount)
//   let computerNum = getRowNumForActionOnStreet(gameObj, "computer", street, lastRow.action, lastRow.betAmount)
//   if (humanNum > computerNum) {
//     humanNum = "2. "
//     computerNum = "1. "
//   } else {
//     humanNum = "1. "
//     computerNum = "2. "
//   }
//   return [humanNum, computerNum]
// }

export function getActionTextByActor(actor, gameObj) {

  let debugFunc = 0
  let msg = ''
  let lastRow = getLastRowByActor(gameObj, actor)
  let finalLastRow = getLastRow(gameObj)
  if (actor === 'computer') {
    if (gameObj.street === 'done' && finalLastRow.actor === 'computer'
      && (finalLastRow.action === 'call' || finalLastRow.action === 'check')
    ) {
      msg += capitalizeFirstLetter(finalLastRow.street) + ": " + getDisplayAction(finalLastRow.action) + "."
    } else if (lastRow.action === 'smallBlindCall' && lastRow.actor === 'computer') {
      msg += "Preflop: calls small blind. "
    } else {
      let secondToLastRow = getSecondToLastRowByActor(gameObj, actor)
      if (debugFunc) console.log("G1 getActionTextByActor lastRow", lastRow)
      if (debugFunc) console.log("getActionTextByActor streetHistoryArr", gameObj.streetHistoryArr)
      if (lastRow.action !== 'smallBlind' && lastRow.action !== 'bigBlind') {
        if (secondToLastRow.action === 'smallBlindCall' && secondToLastRow.actor === 'computer'
          && lastRow.actor === 'computer' && lastRow.action === 'raise' && secondToLastRow.street === lastRow.street)
        {
          // if small blind raises, add smallBlindCall to text
          msg += "Preflop: calls small blind and raises " + lastRow.betAmount + "."
        } else if (secondToLastRow.action === 'call' && lastRow.action === 'raise' && lastRow.actor === 'computer'
          && secondToLastRow.actor === 'computer' && secondToLastRow.street === lastRow.street
        ) {
          msg += capitalizeFirstLetter(secondToLastRow.street) + ": calls " + secondToLastRow.betAmount
          msg += " and raises " + lastRow.betAmount + "."
        } else {
          if (secondToLastRow.actor === 'computer' && gameObj.bigBlindPlayer === 'computer' && secondToLastRow.action === 'call') {
            msg += capitalizeFirstLetter(secondToLastRow.street) + ": " + getDisplayAction(secondToLastRow.action)
            msg += " " + secondToLastRow.betAmount +  ".<br />"
          }
          msg += capitalizeFirstLetter(lastRow.street) + ": " + getDisplayAction(lastRow.action)
          if (lastRow.betAmount > 0) {
            msg += " " + lastRow.betAmount
          }
          msg += ". "
        }
        if (debugFunc) console.log("G2 getActionTextByActor", msg)
      }
    }
  } else {

    //   if (actor === 'computer' && finalLastRow.actor === 'human' && finalLastRow.street === 'preflop'
    //     && (finalLastRow.action === 'call' || finalLastRow.action === 'check')) {
    //     msg = ''
    //     if (debugFunc) console.log("getActionTextByActor X1")
    //   } else
    if (lastRow.action === 'smallBlind') {
      msg += "Preflop: action to Human."
    } else if (finalLastRow.actor === 'computer' && gameObj.playerBetTurn === 'human' && actor === 'human' && gameObj.street !== 'done') {
      msg += capitalizeFirstLetter(gameObj.street) + ": action to Human."
    } else if (lastRow.action === 'call' && lastRow.actor === 'human' && gameObj.playerBetTurn === 'human' && actor === 'human' && gameObj.bigBlindPlayer === 'human') {
      if (debugFunc) console.log("getActionTextByActor X2")
      msg += capitalizeFirstLetter(lastRow.street) + " calls " + lastRow.betAmount + ". <br />"
      msg += capitalizeFirstLetter(gameObj.street) + ": action to Human."
    } else if ((lastRow.action === 'check' || lastRow.action === 'call') && lastRow.actor === 'computer' && gameObj.playerBetTurn === 'human' && actor === 'human' && gameObj.bigBlindPlayer === 'human' && lastRow.street !== gameObj.street) {
      if (debugFunc) console.log("getActionTextByActor X3")
      msg += capitalizeFirstLetter(gameObj.street) + ": action to Human."
    } else if (finalLastRow.street === 'preflop' && finalLastRow.actor === 'human'
      && gameObj.street === 'flop' && actor === 'human' && (finalLastRow.action === 'call' || finalLastRow.action === 'check')
    ) {
      if (debugFunc) console.log("getActionTextByActor X4")
      msg += "Flop: action to Human."
    } else if (lastRow.action === 'fold' && lastRow.actor === 'human') {
      msg += capitalizeFirstLetter(lastRow.street) + ": folds."
    } else if (lastRow.actor === 'human') {
      msg += capitalizeFirstLetter(lastRow.street) + ": " + getDisplayAction(lastRow.action)
      if (lastRow.betAmount > 0) {
        msg += " " + lastRow.betAmount
      }
      msg+= "."
    }

  }

  if (debugFunc) console.log("getActionTextByActor gameObj", gameObj)


  return msg

}

export function getChipImg() {
  return "<img class = 'chipImg' src=\"data:image/png;base64,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\" />"
}